// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M11 1.5C12.1 1.5 13 2.4 13 3.5V12.83C13 13.35 12.44 13.68 11.99 13.42L8.99 11.71C8.38 11.36 7.62 11.36 7.01 11.71L4.01 13.42C3.56 13.68 3 13.35 3 12.83V3.5C3 2.4 3.9 1.5 5 1.5H11Z',
  'M5.65 6.25L7 7.6L9.9 4.7',
];
